

























import { Vue, Prop, Component } from "vue-property-decorator";

import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import commons from "@/common/store/modules/commons";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheTemplateM,
    ButtonMain
  }
})
export default class MyPageEmailSettingsError extends Vue {
  @Prop({ type: String, required: true }) message!: string;

  step = 4;
  get stepOptions() {
    return [
      { step: 1, label: "入力" },
      { step: 2, label: "メール確認" },
      { step: 3, label: "本人認証" },
      { step: 4, label: "完了" }
    ];
  }

  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page/",
      pageType: "lower"
    },
    {
      text: "メールアドレス変更",
      url: "",
      pageType: "lower"
    }
  ];

  mounted() {
    AuthStorage.checkLogin();
  }

  created() {
    commons.getBreadcrumb(this.breadcrumb);
  }
}
